import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { supplementaryMaterialAccepted } from "store/actions/supplementaryMaterialActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SupplementaryMaterialTodoFooterProps } from "models/propTypes/supplementaryMaterialPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import SupplementaryMaterialTodoMoreActions from "./footerMoreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SupplementaryMaterialTodoFooter: React.FC<SupplementaryMaterialTodoFooterProps> = (props) => {
  const { supplementaryMaterial, markAsDoneHandler } = props;

  const dispatch = useDispatch();

  const onAcceptSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(supplementaryMaterialAccepted(supplementaryMaterial.id));
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accept),
          onClick: props.onTodoClear,
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onAcceptSuccess,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupplementaryMaterial.TodoSubmitSuccess
          ),
        },
      ]}
      moreActions={
        <SupplementaryMaterialTodoMoreActions
          supplementaryMaterial={supplementaryMaterial}
          markAsDoneHandler={markAsDoneHandler}
        />
      }
      disableSuccessMessages
    />
  );
};

export default SupplementaryMaterialTodoFooter;
